import type { ThemeOptions } from "@material-ui/core/styles";

const props: ThemeOptions["props"] = {
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiCardHeader: {
    titleTypographyProps: { variant: "h6" },
  },
};

export default props;
